<template>
  <div id="enroll">
    <Banner title="活動報名" :breadcrumbs="breadcrumbs" type="enroll"></Banner>
    <div class="container">
      <div class="center_title">
        <Title en="Online registration" chtFirst="線上" chtSecond="報名" :center="true"></Title>
      </div>
      <section class="list_box">
        <div
          class="list"
          v-if="!isDetail"
          v-infinite-scroll="loadMore"
          infinite-scroll-disabled="busy"
          infinite-scroll-distance="10"
          v-show="List.length > 0"
        >
          <div class="item" v-for="(item,index) in List" :key="item.Id">
            <Card :eventData="item" />
          </div>
        </div>
        <notfound v-if="List.length == 0" info="目前尚未開放活動報名，"></notfound>
      </section>
      <section class="detail" v-if="isDetail && Step == 1 ">
        <div class="box">
          <div class="title">{{eventDetail.Title}}</div>
          <div class="global_title"></div>
          <div class="table_span">
            <div class="subtitle">活動時間</div>
            <div class="content">{{JoinStartDate + " ~ " + JoinEndDate}}</div>
          </div>
          <div class="table_span" v-if="eventDetail.DocumentFile">
            <div class="subtitle">檔案下載</div>
            <div class="content">
              <a href="javascript:;" @click="download(eventDetail.DocumentFile)">
                <pdficon></pdficon>
                <span>相關資料(節目表)</span>
              </a>
            </div>
          </div>
          <div class="table_span" v-if="eventDetail.RequirePayment">
            <div class="subtitle">
              報名費
              <br />說明
            </div>
            <div class="content none">
              <div class="th">
                <span>項目</span>
                <span v-for="(fee,index) in FeeItems" :key="index">{{fee.Title}}<br />{{$moment(fee.EndOn).format("LL")}}前</span>
              </div>
              <div class="td">
                <span>視網膜醫學會會員</span>
                <span v-for="(fee,index) in FeeItems" :key="index">NTD {{fee.Membership}}</span>
              </div>
              <div class="td">
                <span>眼科專科醫師</span>
                <span v-for="(fee,index) in FeeItems" :key="index">NTD {{fee.Specialist}}</span>
              </div>
              <div class="td">
                <span>住院醫師、研究醫師、學生</span>
                <span v-for="(fee,index) in FeeItems" :key="index">NTD {{fee.Internship}}</span>
              </div>
              <div class="td">
                <span>隨同親友及其他</span>
                <span v-for="(fee,index) in FeeItems" :key="index">NTD {{fee.Companion}}</span>
              </div>
            </div>
            <div class="content pc_none">
              <ul v-for="(fee,index) in FeeItems" :key="index">
                <li>
                  {{fee.Title}}
                  <span>{{$moment(fee.EndOn).format("LL")}}前</span>
                </li>
                <li>
                  <span>眼科專科醫師</span>
                  <span>NTD {{fee.Specialist}}</span>
                </li>
                <li>
                  <span>視網膜醫學會會員</span>
                  <span>NTD {{fee.Membership}}</span>
                </li>
                <li>
                  <span>住院醫師、研究醫師、學生</span>
                  <span>NTD {{fee.Internship}}</span>
                </li>
                <li>
                  <span>隨同親友及其他</span>
                  <span>NTD {{fee.Companion}}</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="img">
            <img :src="eventDetail.Image || require('@/assets/default-small.png')"/>
          </div>
          <article v-html="eventDetail.Content"></article>
          <ul class="info">
            <!-- <li>中華民國視網膜醫學會</li> -->
            <!-- <li>日期 : {{$moment(eventDetail.StartOn).locale('zh-tw').format('LL')}}</li> -->
            <li>地點 : {{eventDetail.Location}}</li>
            <li>主辦 : {{eventDetail.Organizer?eventDetail.Organizer:'無'}}</li>
            <li>協辦 : {{eventDetail.CoOrganizer?eventDetail.CoOrganizer:'無'}}</li>
          </ul>
          <!-- 關閉非會員報名活動的報名按鈕 -->
          <div class="btn_box" v-if="eventDetail.RequireRegister && eventDetail.Id !== '8e4678df-b3c5-4ebb-921b-fd31afbff49e' && eventDetail.Id !== '2e13f703-33d9-47a0-8e7c-9126189fe2b4' && eventDetail.Id !== '24ffdf77-8a31-4391-8615-2a474387c297'&& eventDetail.Id !== '35030ff7-cebc-414c-8b2c-cd770a6321f2'&& eventDetail.Id !== 'b5975495-ad9b-4d43-a169-ccb495d0c684'">
            <div class="Orange_btn islogin" @click="nextStep(false)">
              <a href="javascript:;">前往報名</a>
            </div>
          </div>
        </div>
        <graybtn url="/Event/Index" name="回上一頁"></graybtn>
      </section>
      <transition>
        <section class="detail" v-if="Step == 2">
          <div class="box">
            <div class="global_title nomb">活動基本資訊</div>
            <div class="act">
              <div class="title">{{eventDetail.Title}}</div>
              <div class="info">
                <div class="img">
                  <img :src="eventDetail.Image || require('@/assets/default-small.png')" :alt="eventDetail.Title" />
                </div>
                <ul class="text">
                  <li>中華民國視網膜醫學會</li>
                  <li>服務專線:0965-106869</li>
                  <!-- <li>報名開始:{{$moment(eventDetail.RegisterStartOn).locale('zh-tw').format('LL')}}</li> -->
                  <li>活動時間:{{$moment(eventDetail.RegisterStartOn).locale('zh-tw').format('LL')}} ~ {{ $moment(eventDetail.RegisterEndOn).locale('zh-tw').format('LL') }}</li>
                  <li>地點 : {{eventDetail.Location}}</li>
                  <li>主辦 : {{eventDetail.Organizer ? eventDetail.Organizer:'無'}}</li>
                  <li>協辦 : {{eventDetail.CoOrganizer ? eventDetail.CoOrganizer:'無'}}</li>
                </ul>
              </div>
              <div class="btn_box"></div>
            </div>
            <div class="global_title nomb">報名人資訊</div>
            <div class="member">
              <div class="input_span">
                <span>中文姓名*</span>
                <input type="text" placeholder="輸入中文姓名" required v-model="JoinEvent.Name" />
              </div>
              <div class="input_span">
                <span>英文姓名*</span>
                <input type="text" placeholder="輸入英文姓名" required v-model="JoinEvent.EngName" />
              </div>
              <div class="input_span">
                <span>聯絡電話*</span>
                <input type="text" placeholder="請輸入連絡電話" required v-model="JoinEvent.Mobile" />
              </div>
              <div class="input_span">
                <span>E-mail*</span>
                <input type="email" placeholder="請輸入電子郵件" required v-model="JoinEvent.Email" />
              </div>
              <div class="input_span">
                <span>服務單位*</span>
                <input type="text" placeholder="請輸入服務單位" required v-model="JoinEvent.Affiliation" />
              </div>
              <!-- <div class="input_span">
                <span>職稱*</span>
                <input type="text" placeholder="請輸入職稱" required v-model="JoinEvent.Position" />
              </div> -->
              <div class="input_span" v-if="eventDetail.Id !== '97b95ebf-8f0b-40cc-98fc-f68692434129'">
                <span>稱謂*</span>
                <select v-model="JoinEvent.Title">
                  <option value="null" disabled>請選擇稱謂</option>
                  <option value="醫師">醫師</option>
                  <option value="教授">教授</option>
                  <option value="研究生">研究生</option>
                  <option value="住院醫生">住院醫生</option>
                </select>
              </div>
              <div class="input_span" v-else>
                <span>參加7/13（日）東密道導覽*</span>
                <select v-model="JoinEvent.Title">
                  <option value="null" disabled>請選擇</option>
                  <option value="參加">參加</option>
                  <option value="不參加">不參加</option>
                </select>
              </div>
              <div class="input_span">
                <span>葷素類別</span>
                <select v-model="JoinEvent.IsVegetarian">
                  <option value="false">葷</option>
                  <option value="true">素</option>
                </select>
              </div>
              <div class="input_span" v-if="eventDetail.Id !== '97b95ebf-8f0b-40cc-98fc-f68692434129'">
                <!-- <span v-if="eventDetail.Id == 'bdcfb195-89ee-424f-ba7c-c69bcdced722'">7/27限定派對</span> -->
                <span>晚宴</span>
                <select v-model="JoinEvent.IsAttendDinner">
                  <option value="true">參加</option>
                  <option value="false">不參加</option>
                </select>
              </div>
              <div class="input_span" v-else>
                <span>7/13 (日) 16:40交通車前往台北高鐵站</span>
                <select v-model="JoinEvent.IsAttendDinner">
                  <option value="true">需搭乘</option>
                  <option value="false">不需搭乘</option>
                </select>
              </div>
              <div class="input_span" v-if="eventDetail.Id == 'd4741ac6-b8a2-419a-bc78-40b54555474c'">
                <span></span>
                <a href="https://forms.gle/VCispw6ezXX4JHuF9" target="_blank" rel="noreferrer noopener">高雄圓山大飯店訂房單</a>
              </div>
            </div>
            <!-- 2020/09/25 暫時隱藏起來 -->
            <!-- <div class="global_title nomb">
              隨行朋友
              <span>總人數 : {{Friends.length}}</span>
              <button @click="addFriend">+ 增加</button>
            </div>
            <div class="friend">
              <div class="item animated fadeIn" v-for="(friend,index) in Friends" :key="index">
                <div class="title">
                  <span>隨行親友{{index + 1 }}</span>
                  <span @click="removeFriend(index)">✘</span>
                </div>
                <div class="input_span">
                  <span>中文姓名</span>
                  <input type="text" v-model="friend.Name" placeholder="請輸入中文姓名" required />
                </div>
                <div class="input_span">
                  <span>英文姓名</span>
                  <input type="text" v-model="friend.EngName" placeholder="請輸入英文姓名" required />
                </div>
                <div class="input_span">
                  <span>稱謂</span>
                  <select v-model="friend.Title">
                    <option value="null" disabled>請選擇稱謂</option>
                    <option value="教授">教授</option>
                    <option value="研究生">研究生</option>
                  </select>
                </div>
                <div class="input_span">
                  <span>葷素類別</span>
                  <select v-model="friend.IsVegetarian">
                    <option value="false">葷</option>
                    <option value="true">素</option>
                  </select>
                </div>
                <div class="input_span">
                  <span>晚宴</span>
                  <select v-model="friend.IsAttendDinner">
                    <option value="true">是</option>
                    <option value="false">否</option>
                  </select>
                </div>
              </div>
            </div> -->
            <div class="global_title nomb" v-if="eventDetail.RequirePayment">報名費</div>
            <div class="cost" v-if="eventDetail.RequirePayment">
              <div class="title" :class="{'isMember':IsEarly}">{{PriceType.Title}}</div>
              <ul class="signtpye">
                <li>
                  <span>{{payName}}</span>
                  <span>NTD {{paySelf}}</span>
                </li>
                <li v-if="Friends.length > 0">
                  <span>隨同親友即其他({{Friends.length}}名)</span>
                  <span>NTD {{Friendprice * Friends.length}}</span>
                </li>
              </ul>
            </div>
            <div class="global_title nomb" v-if="eventDetail.RequirePayment"></div>
            <div class="total" v-if="eventDetail.RequirePayment">
              <span>總計</span>
              <span>NTD {{paySelf + Friendprice * Friends.length}}</span>
            </div>
            <div class="btn_box" v-if="eventDetail.RequireRegister">
              <div class="Orange_btn islogin" @click="checkout">
                <a href="javascript:;">{{eventDetail.RequirePayment?'前往繳費':'我要報名'}}</a>
              </div>
            </div>
          </div>
          <graybtn :url="`/Event/Index?Id=${isDetail}`" name="回上一頁"></graybtn>
        </section>
      </transition>
    </div>
    <Popup @closePopup="closeMemberPop" v-if="MemberPopup">
      <!-- <p>{{ismember?"請選擇您的活動報名項目":"報名活動需要登入會員"}}</p>
      <p>{{ismember?"到場後將會有專人驗證，請確認您的選擇!":"如果您還未成為會員，請先註冊完再來進行活動報名!"}}</p> -->
      <p>{{ismember?"請選擇您的活動報名項目":"報名活動需要登入會員並完成認證繳交會費，如您未繳交年費請先繳交年費後再報名。"}}</p>
      <p>{{ismember?"到場後將會有專人驗證，請確認您的選擇!":"如果您還未成為會員或尚未完成認證繳交會費，請先完成註冊或完成認證繳交會費後再來進行活動報名!"}}</p>
      <p v-if="!ismember && islogin">您尚未完成會費繳納，請點選下方按鈕前往繳納</p>
      <div class="btn_box" v-if="ismember">
        <div class="item">
          <div class="White_btn islogin" @click="nextStep(true,'Membership')">
            <a href="javascript:;">付費會員</a>
          </div>
        </div>
        <!-- <div class="item">
          <div class="White_btn islogin" @click="nextStep(true,'Specialist')">
            <a href="javascript:;">眼科專科醫師</a>
          </div>
        </div>
        <div class="item">
          <div class="White_btn islogin" @click="nextStep(true,'Internship')">
            <a href="javascript:;">住院醫師</a>
          </div>
        </div> -->
      </div>
      <div class="btn_box" v-if="!ismember && !islogin">
        <div class="item">
          <div class="Orange_btn islogin" @click="openLoginbox">
            <a href="javascript:;">會員登入</a>
          </div>
        </div>
        <div class="item">
          <div class="Orange_btn islogin">
            <a href="/Home/Registration">會員註冊</a>
          </div>
        </div>
      </div>
      <div class="btn_box" v-if="!ismember && islogin">
        <div class="item">
          <div class="Orange_btn islogin">
            <a href="/Member/Status">繳納會費</a>
          </div>
        </div>
      </div>
    </Popup>
    <Popup @closePopup="closeCheckpopup" v-if="checkStatus" @click="goHome">
      <p>恭喜您!已完成這次"活動報名"</p>
      <!-- <p>您的報名成功通知信已經寄至</p>
      <span>{{JoinEvent.Email}}</span> -->
      <p>可以至"會員專區 > 活動報名紀錄"確認此次報名資訊。</p>
      <!-- <p>
        如果經過一段時間，您仍沒有收到
        <span>中華民國視網膜醫學會</span>的帳號驗證遊件，郵件有可能被分類到垃圾信件。請查看您的垃圾郵件信件箱。
      </p>
      <p>
        請設置
        <span>twrs.tw@gmail.com</span>郵件為非垃圾郵件，並加入為聯絡人，避免郵件丟失。
      </p> -->
      <div class="btn_one_box">
        <div class="Orange_btn islogin" @click="isfinish">
          <a href="javascript:;">確認</a>
        </div>
      </div>
    </Popup>
    <loading v-if="isLoading"></loading>
  </div>
</template>

<script>
import Card from "@/components/enroll/imgCard";
import Popup from "@/components/popup";
import Common from "@/common";
import API from "@/service/activity";
export default {
  name: "enroll",
  components: {
    Card,
    Popup
  },
  props: {
    activities: {
      type: Array
    },
    ismember: {
      type: Boolean
    },
    islogin: {
      type: Boolean
    }
  },
  data() {
    return {
      breadcrumbs: [
        {
          url: "/",
          title: "首頁"
        },
        {
          title: "活動報名"
        },
        {
          url: "/enroll",
          title: "線上報名"
        }
      ],
      List: [],
      TotalPage: 1, //總頁數
      Page: 1, //現在頁數
      Count: 10, //一頁的總筆數
      busy: false,
      isDetail: false, //是否進入到詳細頁
      Detail: [],
      Step: 1, //步驟 1 為詳細 2為報名
      MemberPopup: false, //提醒登入會員POPUP狀態
      checkStatus: false, //交易成功POPUP狀態
      Items: [],
      payName: "",
      paySelf: 0,
      eventDetail: {},
      eventJoin: {
        Id: "9acaddasdhhyth",
        Title:
          "第八屆視網膜醫學會年會Free Paper 及第四屆台日聯合會Rapid Fire聯合徵稿活動",
        Image: require("@/assets/dev/member1.png"),
        Date: "108年3月31日(星期日)時間:8:30 ~ 9:30",
        Location: "台北榮民總醫院斯奧援山分院",
        MainHand: "中華民國視網膜醫學會/台北榮民總醫院",
        AssistHand: "陽明大學附設醫院",
        Sponsor: "台灣拜耳股份公司",
        MemberName: "陳義山",
        MemberNameEn: "YI SHAN CHEN",
        Tel: "0977123456",
        Email: "123@123.com",
        Service: "馬靴醫院",
        Job: "眼科主治醫師",
        Appellation: "先生",
        IsMember: true,
        Eat: 1,
        Banquet: "喜來登晚宴(11/3)",
        Isjoin: true,
        Early: "2019-07-05",
        Total: 6500
      },
      Friends: [],
      TicketTypes: {
        Early: {
          Main: 0,
          Member: 3000,
          Postgraduate: 1000,
          Other: 3000
        },
        General: {
          Main: 1000,
          Member: 3500,
          Postgraduate: 1250,
          Other: 3500
        }
      },
      JoinEvent: {
        Title: "null",
        Name: "",
        EngName: "",
        Telephone: "",
        Mobile: "",
        Email: "",
        Affiliation: "",
        Position: "default",
        ZipCode: "",
        Address: "",
        SelectedFee: 0, //0會員 1專科醫施 2住院醫師、研究醫師、學生
        IsVegetarian: false,
        IsAttendDinner: false, // 20240701 暫時更改為預設 false
        MemberId: "",
        ActivityId: "",
        Companions: []
      },
      isLoading:false
    };
  },
  methods: {
    loadMore() {
      const vm = this;
      vm.busy = true;
      if (vm.TotalPage == 1 || vm.TotalPage == vm.Page || vm.TotalPage == 0) {
        return false;
      }
      vm.isLoading = true;
      vm.Page += 1;
      API.getActivityList({ page: vm.Page, count: vm.Count }).then(res => {
        if (res.Ok) {
          // 10/25後改回
          vm.List = vm.List.concat(res.Data.Activities.filter(item=>{item.RequireRegister === true}));
          // vm.List = vm.List.concat(res.Data.Activities.filter(item=>{vm.$moment(item.EndOn).format('x') > vm.$moment(new Date()).format('x')}));
          // vm.List = vm.List.concat(obj.Activities.filter(item=>{(item.Id == '5b0aeca2-2a7d-464e-add6-f9c6d71bc140' || 'e85e80d7-e4ac-4082-ad48-5dec2c3af362')}));;
          setTimeout(function() {
            vm.busy = false;
          }, 1000);
        }
        setTimeout(function() {
            vm.isLoading = false;
        }, 500);
      });
    },
    nextStep(Force, type) {
      const vm = this;
      // console.log(Force);
      if (Force) {
        vm.Step = 2;
        vm.MemberPopup = false;
        window.scrollTo(0, 300);

        const PriceIndex = vm.PriceType.Id;
        let prices = vm.FeeItems[PriceIndex];

        vm.$set(vm.JoinEvent, "SelectedFee", type);
        if (type == "Membership") {
          vm.payName = "視網膜醫學會會員";
          vm.paySelf = prices.Membership;
          // vm.$set(vm.JoinEvent, "SelectedFee", 0);
        } else if (type == "Specialist") {
          vm.payName = "眼科專科醫師";
          vm.paySelf = prices.Specialist;
          // vm.$set(vm.JoinEvent, "SelectedFee", 1);
        } else if (type == "Internship") {
          vm.payName = "住院醫師、研究醫師、學生";
          vm.paySelf = prices.Internship;
          // vm.$set(vm.JoinEvent, "SelectedFee", 2);
        }
        return false;
      }
      vm.MemberPopup = true;
      return;
    },
    addFriend() {
      const vm = this;
      let myFriends = vm.Friends;
      let arr = {
        Name: "",
        EngName: "",
        Title: "null",
        IsVegetarian: false,
        IsAttendDinner: true
      };
      myFriends.push(arr);
      // console.log(myFriends);
    },
    removeFriend(index) {
      const vm = this;
      let myFriends = vm.Friends;
      myFriends.splice(index, 1);
      vm.Friends = myFriends;
    },
    //關閉是否有登入會員POPUP
    closeMemberPop() {
      const vm = this;
      vm.MemberPopup = false;
    },
    //登入POPUP
    openLoginbox() {
      const vm = this;
      let Loginbox = document.getElementById("loginbox");
      // console.log(Loginbox);
      vm.MemberPopup = false;
      Loginbox.style.display = "flex";
    },
    checkout() {
      const vm = this;
      // console.log(vm.JoinEvent);

      vm.$set(vm.JoinEvent, "ActivityId", vm.eventDetail.Id);
      if (
        vm.JoinEvent.Name == "" ||
        vm.JoinEvent.EngName == "" ||
        vm.JoinEvent.Mobile == "" ||
        vm.JoinEvent.Email == "" ||
        vm.JoinEvent.Affiliation == "" ||
        vm.JoinEvent.Position == "" ||
        vm.JoinEvent.Title == "null"
      ) {
        vm.$swal({
          type: "warning",
          text: "尚有欄位未填寫，請檢查您的欄位!",
          confirmButtonText: "確定"
        });
        return false;
      }
      if(!Common.IsEmail(vm.JoinEvent.Email)){
        vm.$swal({
          type: "warning",
          text: "Email格式錯誤，請重新填寫!",
          confirmButtonText: "確定"
        });
        return false;
      }
      // console.log("隨同親友", vm.Friends);
      if (vm.Friends.length > 0) {
        let IsNull = vm.Friends.some(
          item => item.Name == "" || item.EngName == "" || item.Title == "null"
        );
        if (IsNull) {
          vm.$swal({
            type: "warning",
            text: "隨行親友欄位，也都記得要填寫完畢哦!",
            confirmButtonText: "確定"
          });
          return false;
        }
        // console.log("IsNull", IsNull);
      }
      vm.$set(vm.JoinEvent, "Companions", vm.Friends);
      // vm.checkStatus = true;f
      vm.isLoading = true;
      API.getSubmitActivity(vm.JoinEvent).then(res => {
        // console.log(res);
        setTimeout(function() {
            vm.isLoading = false;
        }, 500);
        if (res.Ok) {
            if(vm.eventDetail.RequirePayment){
                location.href = res.Data;
            }else{
                vm.checkStatus = true;
            }

        } else {
          let message = "";
          if (res.Message == "You have already been registered!") {
            message = "您已經報名過活動了!";
          } else {
            message = res.Message;
          }
          vm.$swal({
            type: "warning",
            text: message,
            confirmButtonText: "確定"
          });
        }
      });
    },
    //報名成功POPUP
    closeCheckpopup() {
      const vm = this;
      vm.checkStatus = false;
    },
    goHome() {
      location.href = "/";
    },
    download(url) {
      const vm = this;
      let Type = url
        .split("/")
        .pop()
        .split(".")
        .pop();
      Common.download(url, { type: Type });
    },
    isfinish() {
      location.href = "/Member/Record";
    }
  },
  computed: {
    FeeItems() {
      const vm = this;
      let Arr = vm.eventDetail.FeeItems.map((item,index)=>{
        item.Id = index;
        return item;
      });
      return Arr;
    },
    EarlyDate() {
      const vm = this;
      return vm.$moment(vm.FeeItems[0].EndOn).format("YYYY-MM-DD");
    },
    JoinStartDate() {
      const vm = this;
      // 暫時註解 2020/09/23
      // console.log(vm.FeeItems);
      // if(vm.eventDetail.RequirePayment){
      //   // console.log(vm.FeeItems[0].StartOn);
      //   return vm.$moment(vm.FeeItems[0].StartOn).format("YYYY-MM-DD");
      // }else{
        // console.log(vm.eventDetail.RegisterStartOn);
        return vm.$moment(vm.eventDetail.RegisterStartOn).format("YYYY-MM-DD");
      // }

    },
    JoinEndDate() {
      const vm = this;
      // 暫時註解 2020/09/23
      // if(vm.eventDetail.RequirePayment){
      //   let last = vm.FeeItems.length - 1;
      //   return vm.$moment(vm.FeeItems[last].EndOn).format("YYYY-MM-DD");
      // }else{
        return vm.$moment(vm.eventDetail.RegisterEndOn).format("YYYY-MM-DD");
      // }

    },
    Friendprice() {
      const vm = this;
      return vm.FeeItems[vm.PriceType.Id].Companion;
    },
    //判斷有沒有早鳥
    IsEarly() {
      const vm = this;
      let Early = vm.$moment(vm.FeeItems[0].EndOn).valueOf();
      let Now = vm.$moment().valueOf();
      if (Early > Now) {
        return true;
      } else {
        return false;
      }
    },
    PriceType(){
      const vm = this;
      const Now = vm.$moment().valueOf();
      let Type = "";
      let FeeSort = vm.FeeItems.sort((a,b)=>{
        return vm.$moment(a.EndOn).valueOf() > vm.$moment(b.EndOn).valueOf() ? 1 : -1;
      }).filter(fee=>{
          return vm.$moment(fee.EndOn).valueOf() > vm.$moment().valueOf();
      });;
      // console.log(FeeSort[0]);
      return FeeSort[0];
    }
  },
  created() {
    const vm = this;
    let urlparams = Common.GetUrlParams("Id");
    if (urlparams) {
      vm.isDetail = urlparams;
      if (process.env.NODE_ENV === "production") {
        API.getActivityDetail({ Id: urlparams }).then(res => {
            if (res.Ok) {
              // if(res.Data.RequireRegister == false){
              //   location.href = "/";
              // }
              vm.eventDetail = res.Data;

            } else {
              location.href = "/Event/Index";
            }
        });
      }else{
        // vm.eventDetail = {
        //   CategoryId: "3490aec0-8144-46d9-ad99-3d69b7dc63a5",
        //   CoOrganizer: "台北榮民總醫院蘇澳分院",
        //   Content: `<span style="font-family:Arial;"><span style="font-size:13.3333px;">test</span></span><span style="font-family:Arial;font-size:13.3333px;">test</span><span style="font-family:Arial;font-size:13.3333px;">test</span><span style="font-family:Arial;font-size:13.3333px;">test</span><span style="font-family:Arial;font-size:13.3333px;">test</span>`,
        //   Description: "",
        //   DocumentFile: "",
        //   EndOn: "2019-10-30T00:00:00",
        //   FeeItems: [
        //     {
        //       Companion: 10,
        //       EndOn: "2019-09-30T16:26:45",
        //       Internship: 10,
        //       Membership: 100,
        //       Specialist: 100,
        //       StartOn: "2019-09-16T16:26:45",
        //       Title: "特惠價"
        //     },
        //     {
        //       Companion: 100,
        //       EndOn: "2019-10-30T16:26:45",
        //       Internship: 102,
        //       Membership: 1002,
        //       Specialist: 1002,
        //       StartOn: "2019-10-01T00:00:00",
        //       Title: "一般價"
        //     }
        //   ],
        //   Id: "a981b63d-7048-4410-8c82-139a117364eb",
        //   Image: "",
        //   Introduction: "testtesttesttesttesttesttesttesttesttest",
        //   Location: "宜蘭老爺行旅",
        //   Organizer: "test",
        //   RegisterEndOn: "2019-09-30T00:00:00",
        //   RegisterStartOn: "2019-09-16T00:00:00",
        //   RequirePayment: true,
        //   RequireRegister: true,
        //   StartOn: "2019-09-16T00:00:00",
        //   Title: "testtest*-helen"
        // }
      }
    }
    if (vm.activities) {
      let obj = JSON.parse(vm.activities);
      // console.log(obj);
      // 10/25後改回
      vm.List = obj.Activities.filter(item=>item.RequireRegister === true);
      // vm.List = obj.Activities.filter(item=> vm.$moment(item.EndOn).format('x') > vm.$moment(new Date()).format('x'));'6157ec23-afdb-4a01-b34d-ea0321da9d08'
      // vm.List = obj.Activities.filter(item=>item.Id == 'e85e80d7-e4ac-4082-ad48-5dec2c3af362');
      // vm.List = vm.List.concat(obj.Activities.filter(item=>item.Id == '5b0aeca2-2a7d-464e-add6-f9c6d71bc140'));
      vm.TotalPage = Math.ceil(parseInt(obj.Total) / vm.Count);
      if (vm.TotalPage == 1 ) {
        vm.busy = true;
      }
    }else{
        let arr = [
          {
            CategoryId: "6157ec23-afdb-4a01-b34d-ea0321da9d08",
            CoOrganizer: null,
            Content: null,
            Description: null,
            DocumentFile: null,
            EndOn: "2020-12-31T00:00:00",
            FeeItems: [],
            Id: "9c04ead2-0fd8-409b-af57-f8a7067acabf",
            Image: "",
            Introduction: "",
            Location: "Japan Nagasaki",
            Organizer: "",
            RegisterEndOn: "2019-12-08T00:00:00",
            RegisterStartOn: "2019-12-06T00:00:00",
            RequirePayment: true,
            RequireRegister: true,
            StartOn: "2019-09-01T00:00:00",
            Title: "JRVS 第四屆台日聯合會議",
          },
          {
            CategoryId: "e85e80d7-e4ac-4082-ad48-5dec2c3af362",
            CoOrganizer: null,
            Content: null,
            Description: null,
            DocumentFile: null,
            EndOn: "2020-12-31T00:00:00",
            FeeItems: [],
            Id: "9c04ead2-0fd8-409b-af57-f8a7067acabf",
            Image: "",
            Introduction: "",
            Location: "Japan Nagasaki",
            Organizer: "",
            RegisterEndOn: "2019-12-08T00:00:00",
            RegisterStartOn: "2019-12-06T00:00:00",
            RequirePayment: true,
            RequireRegister: true,
            StartOn: "2019-09-01T00:00:00",
            Title: "JRVS 第四屆台日聯合會議",
          }
      ];
      // let _arr = arr.filter(item=>item.RequireRegister === true);
      // let _arr = arr.filter(item=>vm.$moment(item.EndOn).format('x') > vm.$moment(new Date()).format('x'));
      let _arr = arr.concat(arr.filter(item=>{(item.Id == 'e85e80d7-e4ac-4082-ad48-5dec2c3af362'||"6157ec23-afdb-4a01-b34d-ea0321da9d08")}));
      vm.List = _arr;
    }
  },
  mounted() {},
  watch: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* list */
#enroll .list_box {
    margin-bottom: 60px;
}
#enroll .list {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  align-content: stretch;
  justify-content: space-between;
  margin-bottom: 60px;
}
#enroll .list:after {
  content: "";
  flex: 0 0 30%;
  width: 30%;
  max-width: 350px;
}
#enroll .list .item {
  width: 30%;
  max-width: 350px;
  margin-bottom: 25px;
}
@media screen and (max-width: 767px) {
  #enroll .list .item {
    width: 100%;
    max-width: none;
  }
}
/* detail */
#enroll .detail .box {
  border: 8px solid #eee;
  padding: 20px;
  letter-spacing: 2px;
  line-height: 1.5;
  color: #666;
}
#enroll .detail .box > .title {
  font-size: 1.75rem;
  /* margin-bottom: 30px; */
  color: #333;
  font-weight: 600;
}
#enroll .detail .box .img {
  padding: 20px 0;
  width: 100%;
  margin: auto;
  font-size: 0;
  /* height: 500px; */
}
#enroll .detail .box > .img img {
  width: 100%;
  /* max-height:100%; */
}
#enroll .detail .box .table_span {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
}
#enroll .detail .box .table_span .subtitle {
  background-color: #eee;
  width: 120px;
  text-align: center;
  margin-right: 15px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
#enroll .detail .box .table_span .content {
  border-bottom: 1px solid #eee;
  width: calc(100% - 135px);
  padding: 10px;
}
#enroll .detail .box .table_span .content > a {
  display: flex;
  text-decoration: none;
  color: #333;
  border: 1px solid #eee;
  margin-bottom: 5px;
  padding: 5px;
}
#enroll .detail .box .table_span .content .th {
  display: flex;
  /* justify-content: space-between; */
}
#enroll .detail .box .table_span .content .th > span {
  /* width: 33%; */
  display: flex;
  flex:1;
  align-items: center;
  justify-content: center;
  padding: 10px 0;
  text-align: center;
  color: #fff;
}
#enroll .detail .box .table_span .content .th > span:nth-child(even) {
  background-color: #ee8b59;
}
#enroll .detail .box .table_span .content .th > span:nth-child(odd){
  background: #a59b92;
}
#enroll .detail .box .table_span .content .td {
  display: flex;
  /* justify-content: space-between; */
  padding: 10px;
}
#enroll .detail .box .table_span .content .td + .td {
  border-top: 1px solid #eee;
}
#enroll .detail .box .table_span .content .td > span {
  text-align: center;
  /* width: 33%; */
  flex:1;
}
#enroll .detail .box article {
  padding: 30px 0 20px;
  word-break: break-all;
}
#enroll .detail .box article >>> p {
  padding: 8px 0;
}
#enroll .detail .box article > p.text_indent {
  text-indent: 36px;
}
#enroll .detail .box > .info li {
  padding: 5px 0;
}
#enroll .detail .box .btn_box {
  width: 165px;
  margin: 40px auto;
}
#enroll .detail .box .content.pc_none {
  display: none;
}
@media screen and (max-width: 767px) {
  #enroll .detail .box {
    border: 8px solid #eee;
    padding: 20px 10px;
  }
  #enroll .detail .box .content.none {
    display: none;
  }
  #enroll .detail .box .content.pc_none {
    display: block;
    padding: 0;
    border: none;
  }
  #enroll .detail .box .content.pc_none ul {
    margin-bottom: 20px;
  }
  #enroll .detail .box .content.pc_none ul:nth-child(odd) > li:first-child {
    background-color: #ee8b59;
    color: #fff;
    margin: 10px auto;
    text-align: center;
    padding: 10px 0;
  }
  #enroll .detail .box .content.pc_none ul:nth-child(even) > li:first-child {
    background-color: #a59b92;
    color: #fff;
    margin: 10px auto;
    text-align: center;
    padding: 10px 0;
  }
  #enroll .detail .box .content.pc_none ul > li:not(:first-child) {
    display: flex;
    justify-content: space-between;
    padding: 8px 0;
    font-size: 0.9rem;
    border-bottom: 1px solid #eee;
  }
  #enroll .detail .box .table_span .subtitle,
  #enroll .detail .box .table_span .content {
    width: 100%;
    margin: 0;
    padding: 8px 0;
  }
}
/* STEP2 */
#enroll .detail .box .act,
#enroll .detail .box .member,
#enroll .detail .box .friend,
#enroll .detail .box .cost {
  padding: 0 16px;
  letter-spacing: 2px;
  line-height: 1.5;
  margin-bottom: 20px;
}

#enroll .detail .box .member {
  display: flex;
  flex-direction: column;
  align-items: center;
}
#enroll .detail .box .act .title {
  font-size: 1.4rem;
  margin: 15px 0;
}

#enroll .detail .box .act .info {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
#enroll .detail .box .act .info .img,
#enroll .detail .box .act .info .text {
  width: 49%;
  font-size: 0;
  padding: 0;
}
#enroll .detail .box .act .info .img {
  height: 300px;
}
#enroll .detail .box .act .info .img img {
  width: 100%;
  height: 300px;
  object-fit: contain;
}
#enroll .detail .box .act .info .text {
  font-size: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
#enroll .detail .box .act .info .btn_box {
  padding: 20px 0;
  margin-left: 51%;
}
#enroll .detail .box .friend .item {
  border: 1px solid #eee;
  margin: 15px auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}
#enroll .detail .box .friend .item .title {
  background-color: #eee;
  padding: 8px 16px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
#enroll .detail .box .friend .item .title > span:nth-child(2) {
  color: #f73a41;
  cursor: pointer;
}
#enroll .detail .box .cost .title {
  background-color: #eee;
  padding: 8px 16px;
  margin: 5px auto 15px;
  text-align: right;
}
#enroll .detail .box .cost .title.isMember {
  background-color: #fce9da;
  color: #f73a41;
}
#enroll .detail .box .cost .signtpye {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
#enroll .detail .box .cost .signtpye li {
  padding: 8px 16px;
  display: flex;
}
#enroll .detail .box .cost .signtpye li > span:nth-child(1) {
  margin-right: 16px;
}
#enroll .detail .box .cost .signtpye li > span:nth-child(2),
#enroll .detail .box .total > span:nth-child(2) {
  min-width: 100px;
  text-align: right;
}
#enroll .detail .box .total {
  display: flex;
  justify-content: flex-end;
  padding: 8px 32px;
  letter-spacing: 2px;
  color: #f73a41;
}
#enroll .detail .box .total > span:nth-child(1) {
  margin-right: 16px;
}

#enroll >>> #popup .btn_box {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 575px;
  flex-wrap: wrap;
  margin: 40px auto 20px;
}
#enroll >>> #popup .btn_box > .item {
  width: 32%;
}
#enroll >>> #popup .btn_one_box {
  width: 165px;
  margin: 40px auto 20px;
}
@media screen and (max-width: 767px) {
  #enroll .detail .box .img {
    width: 100%;
  }
  #enroll .detail .box .act .info .img,
  #enroll .detail .box .act .info .text {
    width: 100%;
  }
  #enroll .detail .box .act .info .text {
    padding: 15px 0;
  }
  #enroll .detail .box .act .info {
    margin-bottom: 0;
  }
  #enroll .detail .box .act .info .text li {
    padding: 5px 0;
  }
  #enroll .detail .box .act,
  #enroll .detail .box .member,
  #enroll .detail .box .friend,
  #enroll .detail .box .cost {
    padding: 0;
  }
  #enroll .detail .box .friend .item .input_span {
    padding: 10px;
  }
  #enroll .detail .box .cost .signtpye li {
    padding: 8px 0;
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
  #enroll .detail .box .cost .signtpye li > span:nth-child(1) {
    margin: 0;
  }
  #enroll .detail .box .cost .signtpye li > span:nth-child(2),
  #enroll .detail .box .total > span:nth-child(2) {
    text-align: left;
  }
  #enroll .detail .box .total {
    padding: 8px 0;
  }
  #enroll >>> #popup .btn_box {
    width: 100%;
  }
  #enroll >>> #popup .btn_box > .item {
    width: 100%;
    margin-bottom: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/enroll.vue